import script from "./AlterReturningForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlterReturningForm.vue?vue&type=script&setup=true&lang=ts"

import "./AlterReturningForm.vue?vue&type=style&index=0&id=5c4dad32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4dad32"]])

export default __exports__